import { EnvService } from '@aipb/gulliver/env/util';
import { Injectable } from '@angular/core';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { CompareDialog, Detail, ImageDialog, PrepreparedQuery, SearchForm, SearchResults } from './categories';

@Injectable({
  providedIn: 'root'
})
export class CatalogGoogleAnalyticsService {
  public SEARCH_FORM = new SearchForm(this.ga, this.isEnabled());
  public PREPREPARED_QUERY = new PrepreparedQuery(this.ga, this.isEnabled());
  public SEARCH_RESULTS = new SearchResults(this.ga, this.isEnabled());
  public DETAIL = new Detail(this.ga, this.isEnabled());
  public IMAGE_DIALOG = new ImageDialog(this.ga, this.isEnabled());
  public COMPARE_DIALOG = new CompareDialog(this.ga, this.isEnabled());

  constructor(private ga: GoogleAnalyticsService, private env: EnvService) {}

  private isEnabled() {
    return !!this.env.googleAnalyticsId && this.env.isProduction();
  }
}
